import { lazy, Suspense } from 'react';
const AcademicPlanPage = lazy(() => import('@/pages/AcademicPlanPage'));
import { Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import { AuthProvider } from '@/contexts/AuthContext';
import Layout from '@/components/Layout';
const HomePage = lazy(() => import('@/pages/HomePage'));
import NotFoundPage from '@/pages/NotFoundPage';
import LoginPage from '@/pages/LoginPage';

import EmailVerificationPage from '@/pages/EmailVerificationPage';
import StudentSetupPage from '@/pages/StudentSetupPage';
const TestListPage = lazy(() => import('@/pages/TestListPage'));
const ResultsPage = lazy(() => import('@/pages/ResultsPage'));
const AttendancePage = lazy(() => import('@/pages/AttendancePage'));
const AnnouncementsPage = lazy(() => import('@/pages/AnnouncementsPage'));
const ProfilePage = lazy(() => import('@/pages/ProfilePage'));
const TestInstructionsPage = lazy(() => import('@/components/TestInstructionsModal'));

const EnhancedTestTakingPage = lazy(() => import('@/components/EnhancedTestTakingPage'));
import ForgotPasswordPage from '@/pages/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
const TestResultsPage = lazy(() => import('@/pages/TestResultsPage').then(module => ({ default: module.TestResultsPage })));
const AnalyticsPage = lazy(() => import('@/pages/AnalyticsPage').then(module => ({ default: module.AnalyticsPage })));
import ProtectedRoute from '@/components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Suspense fallback={<div role="status" className="p-6">Loading page…</div>}>
      <Routes>
        <Route path="/login" element={
          <main id="student-main-content" className="student-shell min-h-screen flex flex-col">
            <LoginPage />
          </main>
        } />
        {/* Fullscreen test taking page without layout */}
        <Route path="/test/:testId/take" element={<ProtectedRoute><EnhancedTestTakingPage /></ProtectedRoute>} />
        <Route path="/test/:testId" element={<ProtectedRoute><EnhancedTestTakingPage /></ProtectedRoute>} />

        {/* All other routes with layout */}
        <Route path="/*" element={
          <Layout>
            <Routes>
              <Route path="/verify-email" element={<EmailVerificationPage />} />
              <Route path="/setup" element={<StudentSetupPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
              <Route path="/tests" element={<ProtectedRoute><TestListPage /></ProtectedRoute>} />
              <Route path="/test/:testId/instructions" element={<ProtectedRoute><TestInstructionsPage /></ProtectedRoute>} />

              <Route path="/results" element={<ProtectedRoute><TestResultsPage /></ProtectedRoute>} />
              <Route path="/results/:resultId" element={<ProtectedRoute><ResultsPage /></ProtectedRoute>} />
              <Route path="/analytics" element={<ProtectedRoute><AnalyticsPage /></ProtectedRoute>} />
              <Route path="/academic-plan" element={<ProtectedRoute><AcademicPlanPage /></ProtectedRoute>} />
              <Route path="/attendance" element={<ProtectedRoute><AttendancePage /></ProtectedRoute>} />
              <Route path="/announcements" element={<ProtectedRoute><AnnouncementsPage /></ProtectedRoute>} />
              <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Layout>
        } />
      </Routes>
      <Toaster />
      </Suspense>
    </AuthProvider>
  );
}

export default App;
